import { observer } from "mobx-react-lite";
import React, { FC, useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { loginStore } from "@/modules/login/store";
import GalleryList from "react-photo-gallery";
import GalleryDetail from "@/pages/Gallery/components/GalleryDetail";
import Search from "@/pages/Gallery/components/Search";
import { GalleryItemType, galleryStore } from "@/stores/gallery";
import { useAsyncEffect, useInfiniteScroll, useInViewport } from "ahooks";
import { HeaderWithLogin } from "@/modules/login/ui";
import { getGallery, onAlbum, onFollow, useGalleryAsyncEffect } from "@/pages/Gallery/hooks";
import GalleryItem from "@/pages/Gallery/components/GalleryItem";
import { galleryLangRecords } from "@/pages/Gallery/lang";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { MsgRevEventProps } from "@/utils/buried";
import { Lang } from "@noli/core";
import config from "@/config";
interface FinalPhotosItemType {
  src: string;
  width: number;
  height: number;
  key: string;
  original: string;
  likes?: number;
}
const Gallery: FC<any> = (props) => {
  const lang = langStore.tgt;
  const {
    galleryData: { list: photos, page_size, page_index, sort, counter, author },
    setGalleryData,
    pageLoading,
    setPageLoading,
  } = galleryStore;
  const galleryWrapperRef = React.useRef<HTMLDivElement>(null);
  const searchRef = React.useRef<HTMLDivElement>(null);
  const [inViewport] = useInViewport(searchRef);
  const [current, setCurrent] = useState<number>(0);
  const [detailVisible, setDetailVisible] = useState(false);
  const [columns, setColumns] = useState(5);
  const size = "64px";
  loginStore.setGlobalLoading(false);
  const finalPhotos: FinalPhotosItemType[] = photos?.map((item) => {
    return {
      src: item.image_url,
      width: item.width ?? 300,
      height: item.height ?? 300,
      key: item.image_id.toString(),
      img_id: item.image_id,
      original: item.original,
      user: item.user,
      likes: item.likes,
      is_like: item.is_like,
      is_album: item.is_album,
      album_id: item.album_id,
      album_image_id: item.album_image_id,
      album_name: item.album_name,
      meta_json: item.meta_json,
    };
  });
  useGalleryAsyncEffect();

  useEffect(() => {
    return () => {
      if (inViewport) {
        loginStore.setHeaderSearchNode(<Search inHeader={true} />);
      } else {
        loginStore.setHeaderSearchNode(null);
      }
    };
  }, [inViewport]);
  useEffect(() => {
    galleryWrapperRef.current?.scrollTo(0, 0);
  }, [sessionStorage.keywords, sort, author]);
  // useAsyncEffect(async () => {
  //   if (loginStore?.userState?.userInfo?.userId) {
  //     postMsgRev({
  //       eventParameters: {
  //         event_id: "search_gallery",
  //         event_name: MsgRevEventProps.search_gallery,
  //         event_type: "api",
  //         property: {
  //           search_text: sessionStorage.keywords,
  //         },
  //       },
  //     }).then((res) => {
  //       console.log("埋点");
  //     });
  //   }
  // }, [sessionStorage.keywords, loginStore?.userState?.userInfo?.userId]);
  const onLoadMore: any = () => {
    return new Promise((resolve) => {
      getGallery(true, false, page_index, sort, author).then(
        ({ list, counter }: { list: any; counter: number }) => {
          list &&
            counter &&
            setGalleryData({
              list: page_index === 0 ? list : [...photos, ...list],
              counter: counter ?? 0,
              page_size: page_size,
              page_index: page_index + 1,
              sort,
              author,
            });
          resolve({
            list,
            counter,
          });
        },
      );
    });
  };
  const { noMore } = useInfiniteScroll((d) => onLoadMore(), {
    target: galleryWrapperRef,
    isNoMore: (d?: { list: GalleryItemType[]; counter: any }) => {
      return photos.length >= counter && d?.counter;
    },
    manual: true,
    threshold: 500,
    reloadDeps: [sessionStorage.keywords, sort, author],
  });

  return (
    <Flex
      minW="1280px"
      w="100%"
      bgColor="#080808"
      flexShrink={0}
      bgRepeat="no-repeat"
      bgSize="contain"
    >
      <HeaderWithLogin />
      <Flex
        flexFlow={"row wrap"}
        justifyContent={"center"}
        paddingTop={size}
        w="100%"
        minH="100vh"
        color="#fff"
      >
        <div className={styles.galleryMain} ref={galleryWrapperRef}>
          <Search refs={searchRef} />
          {photos.length >= 1 && (
            <div className={styles.galleryWrapper}>
              <GalleryList
                columns={columns}
                direction="column"
                photos={finalPhotos}
                margin={15}
                renderImage={(data) => {
                  return (
                    <GalleryItem
                      list={photos}
                      key={data.index}
                      setCurrent={setCurrent}
                      data={data}
                      setDetailVisible={setDetailVisible}
                      onAlbum={onAlbum}
                    />
                  );
                }}
              />
              {photos.length === counter && (
                <p className={styles.empty}>
                  {galleryLangRecords[lang as Lang]["End-of-the-Page"]}
                </p>
              )}
            </div>
          )}
        </div>
        {detailVisible && (
          <div className={styles.detailWrapper}>
            <GalleryDetail
              // opusId={5}
              currentID={current}
              backgroundColor={"#27272A"}
              onClose={() => {
                history.back();
                setDetailVisible(false);
              }}
              onAlbum={onAlbum}
              onFollow={onFollow}
            />
          </div>
        )}
        {pageLoading && (
          <div className={styles.loadingWrapper}>
            <img src={`${config.buildCdnBaseUrl}assets/creator/loading-list.gif`} alt="" />
          </div>
        )}
      </Flex>
    </Flex>
  );
};
export default observer(Gallery);
